import img1 from '../Wishlist/images/laptop.png';
import img2 from '../Wishlist/images/dragon.png';
import img3 from '../Wishlist/images/keyboard.png';
import img4 from '../Wishlist/images/control.png';
export const WishData=[{
    id:100,
    img: img1,
    title:"ASUS FHD Gaming Laptop",
    currentPrice:960,
    actualPrice:1160,
    starRate:5,
    discount:-35,
    new:null,
    reviews:65
},{
    id:200,
    img: img2,
    title:"IPS LCD Gaming Monitor",
    currentPrice:1160,
    starRate:5,
    discount:null,
    new:null,
    reviews:65
},{
    id:300,
    img: img3,
    title:"HAVIT HV-G92 Gamepad",
    currentPrice:560,
    starRate:5,
    discount:null,
    new:"NEW",
    reviews:65
},{
    id:400,
    img:img4 ,
    title:"AK-900 Wired Keyboard",
    currentPrice:200,
    starRate:5,
    discount:null,
    new:null,
    reviews:65
},]